import {createSelector} from 'reselect';

import type {NutshellState} from '../../../store';

export const getEditionState = (state: NutshellState) => state.editions;

export const getEditionRecipientListState = createSelector(
    [getEditionState],
    (editionState) => editionState.editionRecipientList
);

export const getIsFilterDrawerOpen = createSelector([getEditionState], (editionState) => {
    return editionState.isFilterDrawerOpen;
});

export const getEditionRecipientListItems = createSelector(
    [getEditionRecipientListState],
    (editionRecipientListState) => {
        return editionRecipientListState.listItems;
    }
);
export const getEditionRecipientListIsLoading = createSelector(
    [getEditionRecipientListState],
    (editionRecipientListState) => {
        return editionRecipientListState.isLoading;
    }
);
export const getEditionRecipientListIsFirstLoad = createSelector(
    [getEditionRecipientListState],
    (editionRecipientListState) => {
        return editionRecipientListState.isFirstLoad;
    }
);
export const getEditionRecipientListHasError = createSelector(
    [getEditionRecipientListState],
    (editionRecipientListState) => {
        return Boolean(editionRecipientListState.errorMessage);
    }
);

export const getEditionRecipientListCount = createSelector(
    [getEditionRecipientListState],
    (editionRecipientListState) => {
        return editionRecipientListState.meta.count ? editionRecipientListState.meta.count : 0;
    }
);

// Membership report
const getEditionEngagementReportState = createSelector(
    [getEditionState],
    (reportState) => reportState.editionEngagementReport
);

const getAudienceMembershipChartState = createSelector(
    [getEditionEngagementReportState],
    (editionEngagementReport) => editionEngagementReport.timeseriesChart
);

export const getCurrentReportChartIsLoading = createSelector(
    [getAudienceMembershipChartState],
    (timeseriesChartState) => timeseriesChartState.isLoading
);
export const isChartTimedOut = createSelector(
    [getAudienceMembershipChartState],
    (timeseriesChartState) => timeseriesChartState.isTimedOut
);

export const isChartErrored = (state: NutshellState) =>
    getAudienceMembershipChartState(state).isErrored;

export const getCurrentReportChartData = createSelector(
    [getAudienceMembershipChartState],
    (timeseriesChartState) => timeseriesChartState.chartData
);
export const getCurrentReportChartPrefix = createSelector(
    [getAudienceMembershipChartState],
    (timeseriesChartState) => timeseriesChartState.prefix
);
export const getCurrentReportChartBucketCount = createSelector(
    [getCurrentReportChartData],
    (chartData) => (chartData ? chartData.buckets.length : 1)
);
